import styled from "styled-components/macro"
import Color from "../../../constants/Color"
import { Link } from "react-router-dom"

export const Container = styled.div`
  width: 100%;
  height: 100%;
  padding: 12px 0;

  @media (min-width: 640px) {
    padding: 18px 0;
  }
`

export const Title = styled.h2`
  font-size: 18px;
  color: ${Color.gray800};
  margin-right: 12px;
  margin-left: 16px;

  @media (min-width: 640px) {
    margin-left: 0px;
  }
  @media (min-width: 1280px) {
    font-size: 24px;
    margin-right: 18px;
  }
`

export const Body = styled.div`
  width: 100%;
  height: 100%;
  padding: 12px 16px;
  display: grid;
  grid-template-columns: repeat(6, minmax(158px, 1fr));
  grid-gap: 16px;
  position: relative;

  @media (min-width: 640px) {
    padding: 18px 0px;
  }

  @media screen and (max-width: 1280px) {
    grid-template-columns: repeat(6, minmax(158px, 1fr));
  }

  @media screen and (max-width: 1024px) {
    grid-template-columns: repeat(4, minmax(158px, 1fr));
  }

  @media screen and (max-width: 768px) {
    grid-template-columns: repeat(3, minmax(158px, 1fr));
  }

  @media screen and (max-width: 600px) {
    grid-template-columns: repeat(2, minmax(158px, 1fr));
  }

  @media screen and (max-width: 375px) {
    grid-template-columns: repeat(0, 1fr);
  }

  @media (min-width: 1280px) {
    grid-gap: 16px;
  }
`

export const Item = styled(Link)`
  width: 100%;
  height: 158px;
  background: linear-gradient(0deg, rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.6)), url(${({ path }) => path});
  object-fit: cover;
  background-size: cover;
  background-position: center;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  transition: all 0.3s ease-in-out;

  &:hover {
    border: 2px solid ${Color.gray800};
    background: linear-gradient(180deg, rgba(14, 165, 233, 0.27) 0%, rgba(12, 163, 232, 0.6) 100%), url(${({ path }) => path});
  }
`

export const Text = styled.h2`
  font-size: 20px;
  color: ${Color.gray100};
`
